import * as React from "react"

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "resize-none flex field-sizing-content w-full rounded-xl border px-3 py-2 text-[14px] shadow-xs transition-[color,box-shadow] outline-none",
        "border-[#E5E7EB] bg-white text-[#0F172A] placeholder:text-[#94A3B8]",
        "focus-visible:border-[#2563EB] focus-visible:ring-[#2563EB]/20 focus-visible:ring-[3px]",
        "dark:border-[#3F3F46] dark:bg-[#27272A] dark:text-[#FAFAFA] dark:placeholder:text-[#71717A]",
        "dark:focus-visible:border-[#60A5FA] dark:focus-visible:ring-[#2563EB]/30",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
